// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import {
    VLayout,
    VCard,
    VDialog,
    VDivider,
    VAlert,
    VCardTitle,
    VCardText,
    VCardActions,
    VSpacer,
    VTooltip,
    VAutocomplete,
    VFlex
} from 'vuetify/lib'

import { Intersect } from 'vuetify/lib/directives/intersect'

Vue.use(Vuetify, {
    components: {
        VLayout,
        VCard,
        VDialog,
        VDivider,
        VAlert,
        VCardTitle,
        VCardText,
        VCardActions,
        VSpacer,
        VTooltip,
        VAutocomplete,
        VFlex
    },
    directives : {
        Intersect
    }
})

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#0b5bd3',
                secondary: '#10233b',
                accent: '#0f766e',
                info: '#38bdf8',
                success: '#14b8a6',
            },
            dark: {
                primary: '#60a5fa',
                secondary: '#dbeafe',
                accent: '#2dd4bf',
                info: '#38bdf8',
                success: '#34d399',
            },
        },
    },
    icons: {
        iconfont: 'mdiSvg',
    },
})
